import type { IconData } from '@stacksjs/iconify-core'

export const natureFire: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0S1 3.5 1 9a7 7 0 1 0 14 0c0-3.315-2.543-5.903-4.563-7.437L8 4zM5.75 11.813C5.75 10.093 8 9 8 9s2.25 1.094 2.25 2.813C10.25 13.02 9.243 14 8 14s-2.25-.98-2.25-2.187\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureFire
